import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.tsx';

import { Skeleton } from '../../atoms/skeleton/skeleton.tsx';
import {
  ItemCard,
  ItemCardBody,
  ItemCardSection,
} from '../item-card/item-card.tsx';
import type { LinkCardProps } from './link-card.tsx';

export const LinkCardSkeleton: React.FC<{
  hideChevron?: LinkCardProps['hideChevron'];
  staticPadding?: LinkCardProps['staticPadding'];
}> = ({ hideChevron, staticPadding }) => {
  return (
    <ItemCard>
      <ItemCardSection staticPadding={staticPadding}>
        <ItemCardBody className="LinkCard__body">
          <div className="shrink-0">
            <Skeleton width={48} height={48} borderRadius={8} />
          </div>

          <div className="flex flex-1 flex-col gap-snug-md">
            <Skeleton width="60%" height={28} borderRadius={4} />
            <Skeleton width="85%" height={16} borderRadius={4} />
          </div>

          {!hideChevron && (
            <div className="flex items-center" style={{ color: '#ebebeb' }}>
              <ArkIcon iconName="chevron-right" size="1.25rem" />
            </div>
          )}
        </ItemCardBody>
      </ItemCardSection>
    </ItemCard>
  );
};
